import React from "react";
import "./style.css";

const OfferTag = ({ hippoOffer = 0, promotionDiscount = 0, rateplanDiscount = 0 }) => {
  const hippoOfferPersent = hippoOffer ? hippoOffer * 100 : 0;
  const rateplanDiscountPersent = rateplanDiscount ? rateplanDiscount * 100 : 0;
  const promotionDiscountPersent = promotionDiscount ? promotionDiscount * 100 : 0;

  return (
    <div className="offer-tag-wrapper">
      {hippoOfferPersent > 0 && (
        <div className="hippo-offer-tag">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.53747 10.9717H9.53754M8.0363 9.47168H8.0423M8.0375 12.4718H8.0435M5.80005 4.01815C7.61989 5.86919 10.6218 1.8743 12.3978 3.32393C13.4196 4.15795 13.0962 6 11.7696 7.20003"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.0987 5.74525C13.6885 5.85265 13.8211 6.20426 13.9969 7.18048C14.1559 8.0601 14.2003 9.11553 14.2003 9.56494C14.1823 9.73146 14.1112 9.88777 13.9975 10.0107C12.7633 11.2318 10.3152 13.5376 9.07976 14.6831C8.59495 15.0917 7.86294 15.1007 7.34812 14.7251C6.2945 13.8304 5.28227 12.8182 4.28985 11.9044C3.89144 11.4196 3.90104 10.7308 4.33545 10.2742C5.64228 8.99312 8.00754 6.80067 9.34317 5.58984C9.47697 5.48184 9.64078 5.41344 9.81718 5.39844C10.116 5.39844 10.6302 5.43624 11.1312 5.46384"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span className="offer-tag-text">{hippoOfferPersent}%</span>
          <span className="offer-tag-text">Hippo Offer</span>
        </div>
      )}
      {rateplanDiscountPersent > 0 && (
        <div className="rateplan-discount-tag">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.53747 10.9717H9.53754M8.0363 9.47168H8.0423M8.0375 12.4718H8.0435M5.80005 4.01815C7.61989 5.86919 10.6218 1.8743 12.3978 3.32393C13.4196 4.15795 13.0962 6 11.7696 7.20003"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.0987 5.74525C13.6885 5.85265 13.8211 6.20426 13.9969 7.18048C14.1559 8.0601 14.2003 9.11553 14.2003 9.56494C14.1823 9.73146 14.1112 9.88777 13.9975 10.0107C12.7633 11.2318 10.3152 13.5376 9.07976 14.6831C8.59495 15.0917 7.86294 15.1007 7.34812 14.7251C6.2945 13.8304 5.28227 12.8182 4.28985 11.9044C3.89144 11.4196 3.90104 10.7308 4.33545 10.2742C5.64228 8.99312 8.00754 6.80067 9.34317 5.58984C9.47697 5.48184 9.64078 5.41344 9.81718 5.39844C10.116 5.39844 10.6302 5.43624 11.1312 5.46384"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span className="offer-tag-text">{rateplanDiscountPersent}%</span>
          <span className="offer-tag-text">Rateplan Discount</span>
        </div>
      )}
      {promotionDiscountPersent > 0 && (
        <div className="promotion-discount-tag">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.53747 10.9717H9.53754M8.0363 9.47168H8.0423M8.0375 12.4718H8.0435M5.80005 4.01815C7.61989 5.86919 10.6218 1.8743 12.3978 3.32393C13.4196 4.15795 13.0962 6 11.7696 7.20003"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.0987 5.74525C13.6885 5.85265 13.8211 6.20426 13.9969 7.18048C14.1559 8.0601 14.2003 9.11553 14.2003 9.56494C14.1823 9.73146 14.1112 9.88777 13.9975 10.0107C12.7633 11.2318 10.3152 13.5376 9.07976 14.6831C8.59495 15.0917 7.86294 15.1007 7.34812 14.7251C6.2945 13.8304 5.28227 12.8182 4.28985 11.9044C3.89144 11.4196 3.90104 10.7308 4.33545 10.2742C5.64228 8.99312 8.00754 6.80067 9.34317 5.58984C9.47697 5.48184 9.64078 5.41344 9.81718 5.39844C10.116 5.39844 10.6302 5.43624 11.1312 5.46384"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span className="offer-tag-text">{promotionDiscountPersent}%</span>
          <span className="offer-tag-text">Getaway Deal</span>
        </div>
      )}
    </div>
  );
};

export default OfferTag;
